import Swiper from 'swiper/bundle';

/*!
* Initializing the gallery on the product page
*/

const element = '.gallery';
const transitionPoint = 768;
const transitionPointSmall = 575;

let galleryThumbs;
let gallery;
let direction;
let timerId = null;

/**
 * Get display direction
 * @returns {string}
 */
let getDirection = () => {
    let windowWidth = $(window).width();

    if (windowWidth <= transitionPoint && windowWidth > transitionPointSmall) {
        return 'horizontal';
    }

    return 'vertical';
};

/**
 * Init gallery
 */
let initSwiper = () => {
    direction = getDirection();

    galleryThumbs = new Swiper('.gallery-thumbs__wrap', {
        direction: getDirection(),
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    gallery = new Swiper('.gallery-top', {
        simulateTouch: false,
        navigation: {
            nextEl: '.gallery .next',
            prevEl: '.gallery .prev',
        },
        thumbs: {
            swiper: galleryThumbs,
            slideThumbActiveClass: 'active',
        },
    });
};

/**
 * To initialize the swipe depending on the conditions
 */
let loadSwipe = () => {
    if (direction) {
        galleryThumbs.destroy(true, true);
        gallery.destroy(true, true);
        initSwiper();

        return;
    }

    initSwiper();
};

/**
 * Start run init
 */
let run = () => {
    $(window).resize(() => {
        if (timerId !== null) {
            clearTimeout(timerId);
        }

        timerId = setTimeout(() => {
            loadSwipe();
        }, 500);
    });

    loadSwipe();
};

/**
 * Init swipe
 */
let init = () => {
    if ($(element).length) {
        run();
    }
};

export {init as initProductGallery};

